module.exports = __webpack_public_path__ + "static/media/response_box.200297aa.jpg";